<template>
    <div>
      <invoice-status-list></invoice-status-list>
    </div>
  </template>
  
  <script>
  export default {};
  </script>
  